var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueBgRightArrowWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.615723,
    width: 35,
    height: 35.7995,
    rx: 8,
    fill: "#4468EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.0156C10.7239 18.0156 10.5 18.2395 10.5 18.5156C10.5 18.7918 10.7239 19.0156 11 19.0156V18.0156ZM24.3536 18.8692C24.5488 18.6739 24.5488 18.3573 24.3536 18.1621L21.1716 14.9801C20.9763 14.7848 20.6597 14.7848 20.4645 14.9801C20.2692 15.1754 20.2692 15.4919 20.4645 15.6872L23.2929 18.5156L20.4645 21.3441C20.2692 21.5393 20.2692 21.8559 20.4645 22.0512C20.6597 22.2464 20.9763 22.2464 21.1716 22.0512L24.3536 18.8692ZM11 19.0156L24 19.0156V18.0156L11 18.0156V19.0156Z",
    fill: "#F8F8FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBgRightArrowWhite);
export default __webpack_public_path__ + "static/media/blue-bg-right-arrow-white.edca32af779aa7d27fb82f7aa51b1e68.svg";
export { ForwardRef as ReactComponent };